import { useContext, useState, useEffect } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const Contact = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere, modalTriggers} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, contact: false}))
		startHere.set((p) => ({ ...p, show: true}))
		modalTriggers.set(p => ({ ...p, contactForm: false }))
		setFirstStepReady(false);
	}
	
	const steps = [
		{
			target: '.contactFirstStep',
			title: "First Contact Record",
			content: 'Create your first contact record.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.contactSecondStep',
			title: "Fill-in Main Details",
			content: 'Save important details of the contact.',
			disableBeacon: true,
			placement: "top",
			modalTriggers: 'contactForm'
		},
		{
			target: '.contactThirdStep',
			title: "Occupation Details",
			content: 'Save occupation details of the contact.',
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.contactFourthStep',
			title: "Cancel Transactions",
			content: "Cancel what you've input.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.contactFifthStep',
			title: "Save Contact Records",
			content: "Save your contact records for the client.",
			disableBeacon: true,
			placement: "top"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.contactFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.contact)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="contact" 
			featureName="setup"
		/>
	);
}
